// Mock data for Kaya Property Management

export const translations = {
  sq: {
    // Navigation
    nav: {
      home: "Ballina",
      about: "Rreth Nesh",
      properties: "Prona",
      services: "Shërbimet",
      contact: "Kontakti",
      admin: "Admin"
    },
    // Hero Section
    hero: {
      title: "Ndërtoni Pasurinë Tuaj të Paluajtshme",
      subtitle: "Dy dekada përvojë në investime luksoze të pasurive të paluajtshme, në Kosovë dhe Shqipëri.",
      cta: "Shfleto Pronat",
      ctaSecondary: "Na Kontaktoni"
    },
    // About Section
    about: {
      title: "Rreth Nesh",
      description: "Kaya Property Management është agjenci e pasurive të paluajtshme me mbi 20 vjet përvojë, e specializuar në investime dhe prona luksoze. Qasja jonë unike ndërthur teknologjinë e avancuar me njohuri të thella të tregut lokal dhe një ndjeshmëri të lartë për dizajnin.",
      experience: "Vite Përvojë",
      properties: "Prona të Shitura",
      clients: "Klientë të Kënaqur",
      specialization: "Specializimi Ynë",
      luxury: "Prona Luksoze",
      investment: "Investime Strategjike",
      technology: "Teknologji e Avancuar",
      local: "Fokus Hiper-Lokal"
    },
    // Services Section
    services: {
      title: "Shërbimet Tona",
      subtitle: "Zgjidhje të plota për çdo nevojë tuajën në pasuri të paluajtshme.",
      sales: {
        title: "Shitje & Blerje",
        description: "Ju përfaqësojmë profesionalisht në çdo transaksion të pasurisë luksoze."
      },
      rental: {
        title: "Menaxhim Qiraje",
        description: "Menaxhim i plotë i pronave me qira afatgjatë dhe Airbnb."
      },
      investment: {
        title: "Këshillim Investimi",
        description: "Analizë tregu dhe strategji investimi për një ROI maksimal."
      },
      property: {
        title: "Menaxhim Prone",
        description: "Shërbime të plota menaxhimi për pronat tuaja."
      }
    },
    // Properties Section
    properties: {
      title: "Prona të Zgjedhura",
      viewAll: "Shiko të Gjitha",
      forSale: "Në Shitje",
      forRent: "Me Qira",
      bedrooms: "Dhoma Gjumi",
      bathrooms: "Banjo",
      area: "m²",
      viewDetails: "Shiko Detajet"
    },
    // Agent Bio Section
    agent: {
      title: "Njihuni me Ekspertin",
      name: "Agjent Profesionist",
      experience: "20 Vjet Përvojë",
      bio: "Me mbi 20 vjet përvojë në tregun e pasurive të paluajtshme, jam i specializuar në investime dhe prona luksoze. Qasja ime unike ndërthur teknologjinë e avancuar me njohuri të thella të tregut lokal, duke u ofruar klientëve tanë avantazhin konkurrues të nevojshëm për vendime të mirinformuara investimi.",
      specialties: "Specialitetet",
      luxury: "Prona Luksoze",
      investment: "Investime",
      international: "Klientë Ndërkombëtarë",
      airbnb: "Menaxhim Airbnb"
    },
    // Market Update Section
    market: {
      title: "Përditësimi i Tregut",
      subtitle: "Të dhënat më të reja të tregut nga 30 ditët e fundit.",
      avgPrice: "Çmimi Mesatar",
      daysOnMarket: "Ditë në Treg",
      inventory: "Inventari",
      growth: "Rritje",
      insights: {
        title: "Pikat Kryesore",
        point1: "Kërkesa për prona luksoze është rritur me 15% në tremujorin e fundit.",
        point2: "Investitorët ndërkombëtarë shfaqin interes të lartë për Prishtinën dhe Tiranën.",
        point3: "Pronat e reja në treg shiten mesatarisht 22% më shpejt sesa një vit më parë."
      }
    },
    // Contact Section
    contact: {
      title: "Na Kontaktoni",
      subtitle: "Jemi këtu për t'ju ndihmuar të gjeni pronën ideale për ju.",
      name: "Emri i Plotë",
      email: "Email",
      phone: "Telefoni",
      message: "Mesazhi",
      send: "Dërgo Mesazhin",
      whatsapp: "Bisedo në WhatsApp",
      info: {
        title: "Informacioni i Kontaktit",
        address: "Prishtinë, Kosovë | Tiranë, Shqipëri",
        email: "info@kaya-group.eu",
        phone: "+383 48 781 888"
      }
    },
    // Footer
    footer: {
      description: "Ndërtoni pasurinë tuaj të paluajtshme krah ekspertëve të besuar në Kosovë dhe Shqipëri.",
      quickLinks: "Lidhje të Shpejta",
      services: "Shërbimet",
      followUs: "Na Ndiqni",
      rights: "Të gjitha të drejtat e rezervuara."
    }
  },
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      properties: "Properties",
      services: "Services",
      contact: "Contact",
      admin: "Admin"
    },
    // Hero Section
    hero: {
      title: "Build Your Real Estate Wealth",
      subtitle: "20 years of experience in luxury real estate investments in Kosovo and Albania",
      cta: "Explore Properties",
      ctaSecondary: "Contact Us"
    },
    // About Section
    about: {
      title: "About Us",
      description: "Kaya Property Management is a real estate agency with 20 years of experience specializing in investments and luxury properties. Our unique approach is technology-oriented with hyper-local focus and excellent design.",
      experience: "Years Experience",
      properties: "Properties Sold",
      clients: "Happy Clients",
      specialization: "Our Specialization",
      luxury: "Luxury Properties",
      investment: "Strategic Investments",
      technology: "Advanced Technology",
      local: "Local Focus"
    },
    // Services Section
    services: {
      title: "Our Services",
      subtitle: "Complete solutions for all your real estate needs",
      sales: {
        title: "Sales & Purchase",
        description: "Professional assistance in luxury property transactions"
      },
      rental: {
        title: "Rental Management",
        description: "Complete management of long-term rentals and Airbnb properties"
      },
      investment: {
        title: "Investment Consulting",
        description: "Market analysis and investment strategies for maximum ROI"
      },
      property: {
        title: "Property Management",
        description: "Complete management services for your properties"
      }
    },
    // Properties Section
    properties: {
      title: "Featured Properties",
      viewAll: "View All",
      forSale: "For Sale",
      forRent: "For Rent",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      area: "sqm",
      viewDetails: "View Details"
    },
    // Agent Bio Section
    agent: {
      title: "Meet the Expert",
      name: "Professional Agent",
      experience: "20 Years Experience",
      bio: "With 20 years of experience in the real estate market, I specialize in investments and luxury properties. My unique approach combines advanced technology with deep local market knowledge, providing my clients with the competitive advantage they need to make informed investment decisions.",
      specialties: "Specialties",
      luxury: "Luxury Properties",
      investment: "Investments",
      international: "International Clients",
      airbnb: "Airbnb Management"
    },
    // Market Update Section
    market: {
      title: "Market Update",
      subtitle: "Latest market data for the last 30 days",
      avgPrice: "Average Price",
      daysOnMarket: "Days on Market",
      inventory: "Inventory",
      growth: "Growth",
      insights: {
        title: "Key Insights",
        point1: "Demand for luxury properties increased 15% in the last quarter",
        point2: "International investors show high interest in Pristina and Tirana",
        point3: "New properties on the market sell 22% faster than last year"
      }
    },
    // Contact Section
    contact: {
      title: "Contact Us",
      subtitle: "We're here to help you find your ideal property",
      name: "Full Name",
      email: "Email",
      phone: "Phone",
      message: "Message",
      send: "Send Message",
      whatsapp: "Contact on WhatsApp",
      info: {
        title: "Contact Information",
        address: "Pristina, Kosovo | Tirana, Albania",
        email: "info@kaya-group.eu",
        phone: "+383 48 781 888"
      }
    },
    // Footer
    footer: {
      description: "Build your real estate wealth with trusted experts in Kosovo and Albania",
      quickLinks: "Quick Links",
      services: "Services",
      followUs: "Follow Us",
      rights: "All rights reserved"
    }
  }
};

export const mockProperties = [
  {
    id: "1",
    title: { sq: "Apartament Luksoz në Prishtinë", en: "Luxury Apartment in Pristina" },
    location: { sq: "Prishtinë, Kosovë", en: "Pristina, Kosovo" },
    price: 250000,
    type: "sale",
    bedrooms: 3,
    bathrooms: 2,
    area: 120,
    image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=800&q=80",
    description: { 
      sq: "Apartament modern me pamje panoramike të qytetit", 
      en: "Modern apartment with panoramic city views" 
    },
    featured: true
  },
  {
    id: "2",
    title: { sq: "Vilë me Pishinë në Tiranë", en: "Villa with Pool in Tirana" },
    location: { sq: "Tiranë, Shqipëri", en: "Tirana, Albania" },
    price: 450000,
    type: "sale",
    bedrooms: 5,
    bathrooms: 4,
    area: 280,
    image: "https://images.unsplash.com/photo-1613490493576-7fde63acd811?w=800&q=80",
    description: { 
      sq: "Vilë luksoze me pishinë dhe oborr të gjelbër", 
      en: "Luxury villa with pool and green yard" 
    },
    featured: true
  },
  {
    id: "3",
    title: { sq: "Apartament për Investim", en: "Investment Apartment" },
    location: { sq: "Prishtinë, Kosovë", en: "Pristina, Kosovo" },
    price: 1500,
    type: "rent",
    bedrooms: 2,
    bathrooms: 1,
    area: 75,
    image: "https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800&q=80",
    description: { 
      sq: "Apartament ideal për qira afatgjatë ose Airbnb", 
      en: "Ideal apartment for long-term rental or Airbnb" 
    },
    featured: true
  },
  {
    id: "4",
    title: { sq: "Penthouse me Pamje Detare", en: "Penthouse with Sea View" },
    location: { sq: "Durrës, Shqipëri", en: "Durres, Albania" },
    price: 380000,
    type: "sale",
    bedrooms: 4,
    bathrooms: 3,
    area: 180,
    image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=800&q=80",
    description: { 
      sq: "Penthouse ekskluziv me pamje të detit Adriatik", 
      en: "Exclusive penthouse with Adriatic Sea views" 
    },
    featured: true
  }
];

export const mockMarketData = {
  avgPrice: { sq: "€185,000", en: "€185,000" },
  daysOnMarket: 45,
  inventoryChange: "+8%",
  growth: "+12%"
};

export const mockAdmin = {
  email: "admin@kaya-group.eu",
  password: "admin123"
};
